var m = require('mithril');
var flatpickr = require('flatpickr/dist/flatpickr');
var styles = require('flatpickr/dist/flatpickr.min.css');
var theme = require('flatpickr/dist/themes/dark.css');
var moment = require('moment-timezone');

/** @namespace */
var pikaday = {};

function toDate(value) {
  if (!value) return null;
  if (value && typeof value.toDate === 'function') {
    return value.toDate();
  }

  var date = moment(value);
  return date.isValid() ? date.toDate() : null;
}

function syncPickerDate(ctrl) {
  if (!ctrl.picker || !ctrl.attrs || !ctrl.attrs.value) return;

  var date = toDate(ctrl.attrs.value());
  if (!date) return;

  var selectedDate = ctrl.picker.selectedDates && ctrl.picker.selectedDates[0];
  if (!selectedDate || selectedDate.getTime() !== date.getTime()) {
    ctrl.picker.setDate(date, false);
  }
}

/**
@param {date} value - the date we're selecting
*/

pikaday.oninit = function (vnode){
  var ctrl = this;
  ctrl.attrs = vnode.attrs
  if (!ctrl.attrs.value()) {
    ctrl.attrs.value(moment())
  }  
}

pikaday.oncreate = function (vnode){
  var ctrl = this;
  ctrl.picker = new flatpickr(vnode.dom, {
    //altInput: true,
    altFormat: "m-d-Y G:i K",
    enableTime: true,
    enableSeconds: true,
    dateFormat: ctrl.attrs.dateFormat || 'Z',
    defaultDate: toDate(ctrl.attrs.value()),
    time_24hr: ctrl.attrs.time_24hr,
    noCalendar: ctrl.attrs.noCalendar,
    //closeOnselect: true,
    onChange: function(selectedDates, dateStr, instance) {
      if (!ctrl.picker.selectedDates[0]) return null;
      var ts = moment.tz(ctrl.picker.selectedDates[0], 'America/New_York');
      var nextValue = ts.clone().tz('UTC'); // Convert this to UTC before it goes to the server
      ctrl.attrs.value(nextValue);
      if (typeof ctrl.attrs.onchange === 'function') {
        ctrl.attrs.onchange(nextValue);
      }
      m.redraw();
      return nextValue;
    }
  })
}

pikaday.onupdate = function (vnode) {
  var ctrl = this;
  ctrl.attrs = vnode.attrs;
  syncPickerDate(ctrl);
}

pikaday.view = function(vnode) {
  var ctrl = this;
  return m('input.w-100.dib', {
    type:'text', 
    placeholder: ctrl.attrs && ctrl.attrs.placeholder || 'Today',
  });
};

module.exports = pikaday;
